module.exports = __webpack_public_path__ + "static/img/can-triple-berry.6e005ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cans/can-triple-berry.png
// module id = /knL
// module chunks = 0